import { X } from "lucide-react";

import type { IconWrapperProps } from "./icon-wrapper";
import { IconWrapper } from "./icon-wrapper";

export function IconClose(props: IconWrapperProps) {
  return (
    <IconWrapper {...props}>
      <X />
    </IconWrapper>
  );
}
